export const GOOGLE_TAG_MANAGER_ID = process.env.REACT_APP_GTM_ID;

declare global {
    interface Window {
        dataLayer?: Record<string, unknown>[];
    }
}

const CUSTOMER_ROUTE_PATTERNS = [
    /^\/(en|sv)?\/?(kirjaudu|login|logga-in)(\/|$)/,
    /^\/(en|sv)?\/?(tili|account|konto)(\/|$)/,
    /^\/(en|sv)?\/?(user)(\/|$)/,
    /^\/(en|sv)?\/?(salasana|password|losenord)(\/|$)/,
    /^\/(en|sv)?\/?(luo_tili|register|skapa-konto)(\/|$)/,
    /^\/(en|sv)?\/?(subscription_end|subscription-ended|prenumeration-avslutad)(\/|$)/,
    /^\/invite\/staff\/customer(\/|$)/,
];

const TERMS_ROUTE_PATTERNS = [
    /^\/(en|sv)?\/?(palveluehdot|terms|terms-of-service|anvandarvillkor)(\/|$)/,
];

export function shouldLoadGoogleTagManager(pathname: string): boolean {
    const normalizedPath = pathname.replace(/\/+$/, "") || "/";

    if (normalizedPath.startsWith("/admin")) return false;
    if (CUSTOMER_ROUTE_PATTERNS.some((pattern) => pattern.test(normalizedPath))) return false;
    if (TERMS_ROUTE_PATTERNS.some((pattern) => pattern.test(normalizedPath))) return false;

    return true;
}

export function installGoogleTagManager(): void {
    if (!GOOGLE_TAG_MANAGER_ID) return;
    if (document.getElementById("google-tag-manager-script")) return;
    if (document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${GOOGLE_TAG_MANAGER_ID}"]`)) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
    });

    const firstScript = document.getElementsByTagName("script")[0];
    const script = document.createElement("script");
    script.id = "google-tag-manager-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GOOGLE_TAG_MANAGER_ID}`;

    if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
    } else {
        document.head.insertBefore(script, document.head.firstChild);
    }
}
